<!--
  スコアを表示する
  @param score: 表示用スコア
-->
<template>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
  <div class="card score-card">
      <div class="card-content">
          <div class="progress-label progress-label-lg color1">
            <span class="progress-title">{{ args.yourScore }}</span><span class="progress-score">{{score}}</span>
          </div>
          <div class="progress">
            <div class="progress-bar bgcolor1" id="progress-bar-myscore" :style="'width: '+score+'%'"></div>
          </div>
          <div class="progress-label color2">
            <span class="progress-title">{{ args.averageScore }}</span><span class="progress-score">66</span>
          </div>
           <div class="progress">
            <div class="progress-bar bgcolor2" :style="'width: 66%'"></div>
          </div>
          <div class="progress-label color3">
            <span class="progress-title">{{ args.maxScore }}</span><span class="progress-score">100</span>
          </div>
          <div class="progress">
            <div class="progress-bar bgcolor3" style="width: 100%" :style="'width: 100%'"></div>
          </div>
      </div>
  </div>
</div>
</template>

<script>
export default {
    props: [
        'score',
        'args'
    ],
}
</script>

<style>
 .color1{
  color: #673AB7;
}

.color2{
  color: #2196F3;
}

.color3{
  color: #FF9800;
}

.bgcolor1{
  background: #673AB7;
}

.bgcolor2{
  background: #2196F3;
}

.bgcolor3{
  background: #FF9800;
}

.progress-label{
  width: 100%;
  font-size: 24px;
}

.progress-score{
  float: right;
}

.progress-label-lg{
  font-size: 32px;
}

.score-card {
  padding: 12px;
}
</style>